export const HIT_CVC_LVL_1 = 'HIT_CVC_LVL_1';
export const GET_CVC_LVL_1 = 'GET_CVC_LVL_1';

export const HIT_CVC_LVL_2 = 'HIT_CVC_LVL_2';
export const GET_CVC_LVL_2 = 'GET_CVC_LVL_2';

export const HIT_CVC_LVL_3 = 'HIT_CVC_LVL_3';
export const GET_CVC_LVL_3 = 'GET_CVC_LVL_3';

export const HIT_CVC_LVL_4 = 'HIT_CVC_LVL_4';
export const GET_CVC_LVL_4 = 'GET_CVC_LVL_4';

export const HIT_CVC_LVL_5 = 'HIT_CVC_LVL_5';
export const GET_CVC_LVL_5 = 'GET_CVC_LVL_5';
